<alliance-carousel *ngIf="state.carouselOptions as carouselOptions" [options]="carouselOptions" class="santa-mt-10">
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.eventsAndComments">
    <p class="santa-typo-regular">{{ translations.content.analyzeActions | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.addTags">
    <p class="santa-typo-regular">{{ translations.content.createPersonalTags | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.createInterviews">
    <p class="santa-typo-regular">{{ translations.content.interviews | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.rejectionReasons">
    <p class="santa-typo-regular">{{ translations.content.rejectionReasons | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.sendResume">
    <p class="santa-typo-regular">{{ translations.content.sendResume | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.externalInteraction">
    <p class="santa-typo-regular">{{ translations.content.informCandidates | translate }}</p>
  </lib-slide-template>
</alliance-carousel>
